import type { Messages } from './en.js';

export const nl: Messages = {
  'app.title': 'Sync Port · P2P-bestandsoverdracht',
  'secure.badge': 'End-to-end versleuteld · rechtstreeks van apparaat naar apparaat · niets wordt op een server bewaard',
  'secure.tooltip':
    'WebRTC-datakanalen zijn tussen de twee apparaten versleuteld met DTLS. De server en het TURN-relay zien alleen versleutelde data.',
  'error.title': 'Verbinding verbroken',
  'error.peerFailed': 'De directe verbinding is mislukt. Controleer het netwerk of de TURN-relayconfiguratie.',
  'error.signaling': 'De signaleringsserver is niet bereikbaar.',
  'error.roomNotFound': 'Er is geen open overdracht voor deze link of pincode. Misschien heeft de verzender de pagina gesloten of is de code verkeerd getypt.',
  'error.roomFull': 'Iemand anders heeft deze link al geopend. Elke link werkt voor één ontvanger.',
  'notFound.tagline': 'Op deze coördinaat is alleen lege ruimte.',
  'notFound.text': 'De pagina die je opende bestaat niet.',
  'notFound.action': 'Bestand versturen',
  'action.startOver': 'Opnieuw beginnen',
  'action.retry': 'Opnieuw proberen',
  'action.cancel': 'Annuleren',
  'action.dismiss': 'Sluiten',
  'sender.tagline': 'Verstuur bestanden tussen apparaten via een privé, versleutelde verbinding. Niets blijft in een baan om de aarde.',
  'drop.title': 'Kies een bestand om te versturen',
  'drop.hint': 'Tik of sleep hier een bestand naartoe · elke grootte',
  'share.title': 'Deel deze link',
  'share.text': 'Open hem op het andere apparaat of scan de code met de camera van een telefoon.',
  'share.linkLabel': 'Deellink',
  'share.copy': 'Link kopiëren',
  'share.native': 'Delen…',
  'share.or': 'of',
  'share.pinHint': 'Voer deze pincode in op de startpagina van het andere apparaat.',
  'share.pinLabel': 'Pincode van de overdracht',
  'share.copied': 'Gekopieerd naar het klembord',
  'share.shared': 'Gedeeld',
  'share.linkMessage': 'Open deze link om een bestand van mij te ontvangen:',
  'share.unavailable': 'Deze browser heeft geen deelmenu van het systeem.',
  'clipboard.blocked': 'De browser blokkeert kopiëren. Selecteer de link en kopieer hem handmatig.',
  'pin.title': 'Heb je een pincode of QR-code?',
  'pin.text': 'Typ de 9-cijferige code van het verzendende apparaat of scan de QR-code ervan.',
  'pin.receive': 'Ontvangen',
  'pin.scan': '📷 Liever de QR-code scannen',
  'pin.incomplete': 'Voer alle {count} cijfers van de pincode in.',
  'scan.hint': 'Richt de camera op de QR-code op het verzendende apparaat',
  'scan.notOurs': 'Die code is geen Sync Port-link. Zoek de code op het verzendende apparaat.',
  'camera.denied': 'Toegang tot de camera is geweigerd. Sta het toe in de browserinstellingen of typ de pincode.',
  'camera.notFound': 'Er is geen camera gevonden op dit apparaat.',
  'camera.busy': 'De camera wordt door een andere app gebruikt.',
  'camera.failed': 'De camera kon niet worden geopend ({reason}).',
  'sender.status.creatingRoom': 'Privékamer wordt aangemaakt',
  'sender.status.waitingReceiver': 'Wachten tot de ontvanger de link opent',
  'sender.status.receiverConnected': 'Ontvanger verbonden, versleuteld direct kanaal wordt geopend',
  'sender.status.waitingDestination': 'Versleuteld kanaal open. Wachten tot de ontvanger een opslaglocatie kiest',
  'sender.status.beaming': 'Bestand wordt door de ruimte gestraald',
  'sender.status.delivered': 'Afgeleverd',
  'status.failed': 'Overdracht mislukt',
  'progress.sending': 'Versturen',
  'progress.receiving': 'Ontvangen',
  'progress.sentDetail': 'Verstuurd {sent} · ontvanger bevestigde {acked}',
  'progress.deliveredDetail': 'De ontvanger heeft het hele bestand.',
  'progress.arrivedDetail': 'Elke byte is aangekomen.',
  'progress.of': '{done} van {total}',
  'progress.speedEta': '{speed} · nog {eta}',
  'route.finding': 'Beste route wordt gezocht',
  'route.direct': 'Directe verbinding',
  'route.nat': 'Directe verbinding via NAT',
  'route.relay': 'Via TURN-relay',
  'route.relayOver': 'Via TURN-relay over {protocol}',
  'sender.sendAnother': 'Nog een bestand versturen',
  'receiver.tagline': 'Inkomende overdracht via een privé, versleutelde verbinding. Houd deze pagina open tot het bestand is geland.',
  'receiver.status.contacting': 'Contact zoeken met de verzender',
  'receiver.status.connected': 'Verbonden met de verzender, versleuteld direct kanaal wordt geopend',
  'receiver.status.channelOpen': 'Versleuteld kanaal open, wachten op de bestandsgegevens',
  'receiver.status.chooseDestination': 'Kies een opslaglocatie om te beginnen met ontvangen',
  'receiver.status.receiving': 'Ontvangen',
  'receiver.status.complete': 'Voltooid',
  'dest.title': 'Klaar om te ontvangen',
  'dest.picker.button': 'Opslaglocatie kiezen',
  'dest.picker.text': '{size} komt binnen. Kies een bestemming; het bestand wordt er rechtstreeks naartoe geschreven.',
  'dest.worker.button': 'Opslaan op dit apparaat',
  'dest.worker.text': '{size} komt binnen. Het wordt rechtstreeks in je Downloads-map geschreven terwijl het binnenkomt.',
  'dest.memory.button': 'Bestand ontvangen',
  'dest.memory.text': '{size} komt binnen. Deze browser houdt het in het tabblad tot je het daarna opslaat.',
  'dest.cancelled': 'Kies een bestemming om te beginnen met ontvangen.',
  'landed.title': 'Veilig geland',
  'landed.chosenFolder': 'Opgeslagen als {name} in de gekozen map.',
  'landed.downloads': 'Opgeslagen in de Downloads-map van de browser.',
  'landed.openWith': 'Openen met…',
  'landed.sendYourself': 'Zelf een bestand versturen',
  'memory.received': '{size} ontvangen. Sla het op dit apparaat op.',
  'memory.save': 'Bestand opslaan',
  'memory.saved': 'Opgeslagen in de Downloads-map van de browser. Je kunt het ook meteen in een andere app openen.',
  'memory.saveAgain': 'Opnieuw opslaan',
  'error.inboxNotFound': 'Dit postvaknummer bestaat niet.',
  'error.inboxUnauthorized': 'De sleutel hoort niet bij dit postvak.',
  'error.declined': 'De eigenaar van het postvak heeft dit bestand geweigerd.',
  'error.inboxLimit': 'Op deze server kunnen geen postvakken meer worden aangemaakt.',
  'home.inboxLink': 'Een postvak aanmaken',
  'inbox.tagline': 'Je vaste postvak. Wie de code scant kan je een bestand aanbieden; jij beslist wat je ontvangt.',
  'inbox.create.title': 'Een postvak aanmaken',
  'inbox.create.text': 'Krijg een vast nummer en QR-code. Wie hem scant kan je een bestand aanbieden; er komt niets binnen voordat je accepteert.',
  'inbox.create.button': 'Mijn postvak aanmaken',
  'inbox.connect.title': 'Al een postvak?',
  'inbox.connect.text': 'Plak de geheime sleutel om het postvak op dit apparaat te gebruiken. Het nummer is optioneel: het kan uit de sleutel worden opgezocht.',
  'inbox.connect.numberOptional': 'Postvaknummer (optioneel)',
  'error.keyUnknown': 'Geen enkel postvak hoort bij deze sleutel.',
  'inbox.connect.number': 'Postvaknummer',
  'inbox.connect.key': 'Geheime sleutel',
  'inbox.connect.button': 'Verbinden',
  'inbox.key.title': 'Je geheime sleutel',
  'inbox.key.text': 'Bewaar het nummer en de sleutel samen op een veilige plek. De sleutel wordt alleen hier getoond en is, samen met het nummer, de enige manier om dit postvak op een ander apparaat te openen.',
  'inbox.key.copy': 'Nummer en sleutel kopiëren',
  'inbox.key.copied': 'Nummer en sleutel gekopieerd',
  'inbox.key.done': 'Ik heb ze bewaard',
  'inbox.number.title': 'Je postvaknummer',
  'inbox.number.text': 'Druk deze code af of toon hem op een scherm. Klanten scannen hem of typen het nummer op de startpagina.',
  'inbox.status.connecting': 'Verbinden met je postvak',
  'inbox.status.online': 'Online. Wachten op klanten',
  'inbox.status.reconnecting': 'Verbinding verbroken. Opnieuw verbinden',
  'inbox.requests.title': 'Binnenkomende verzoeken',
  'inbox.requests.empty': 'Nog geen verzoeken. Ze verschijnen hier zodra een klant een bestand stuurt.',
  'inbox.request.accept': 'Accepteren en opslaan…',
  'inbox.request.decline': 'Weigeren',
  'inbox.request.connecting': 'Geaccepteerd. Verbinden met de klant',
  'inbox.request.cancelled': 'De klant is vertrokken voordat je antwoordde.',
  'inbox.refresh': 'Vernieuwen',
  'inbox.forget': 'Dit postvak op dit apparaat vergeten',
  'toInbox.tagline': 'Een bestand naar postvak {number} sturen. De eigenaar ziet je verzoek en beslist.',
  'toInbox.status.announcing': 'Je bestand wordt bij het postvak aangekondigd',
  'toInbox.status.waitingOnline': 'Afgeleverd bij het postvak. Wachten op goedkeuring',
  'toInbox.status.waitingOffline': 'De eigenaar van het postvak is nu niet online. Je verzoek wacht tot die terug is',
  'toInbox.status.accepted': 'Geaccepteerd. Versleuteld direct kanaal wordt geopend',
  'inbox.print': 'Poster afdrukken (PDF)',
  'poster.title': 'Stuur me je bestanden',
  'poster.number': 'Postvaknummer',
  'poster.step1': 'Scan de code met de camera van je telefoon.',
  'poster.step2': 'Of open {link} en voer het nummer in.',
  'poster.step3': 'Kies het bestand. We accepteren het hier aan de balie.',
  'poster.footer': 'Sync Port · end-to-end versleuteld, rechtstreeks van apparaat naar apparaat. Niets wordt op een server bewaard.',
  'install.title': 'Sync Port installeren',
  'install.native': 'Zet hem op je startscherm voor snelle toegang.',
  'install.ios': 'Tik op ‘Deel’ en dan op ‘Zet op beginscherm’.',
  'install.button': 'Installeren',
};
